var lfjs = lfjs || {};


(function ($) {
  'use strict';

  lfjs.isdocumentready = false;
  lfjs.path = '';
  lfjs.version = 20190909

  lfjs.bubble = function(domobj, message, args, event, belowContent) {
    lfjs.bubble.hide();
    if(typeof lfjs.path == "undefined")
      lfjs.path = $("script[src$='lfjs.js']:first").attr("src").replace(/\/[^\/]*$/, "");
    if(typeof message == "undefined" || message.length == 0)
      return;
    if(typeof args == "undefined")
      var args = {};
    if(typeof lfjs.bubble.domobj == "undefined") {
      lfjs.bubble.createBubble();
    }
    //if dom obj is not visible (i.e. gone or in an old bubble), try to use the previous dom obj
    if(!$(domobj).is(":visible")) {
      if(lfjs.bubble.prevdomobj)
        domobj = lfjs.bubble.prevdomobj;
    } else {
      lfjs.bubble.prevdomobj = domobj;
    }
    var width = 225;
    if(typeof args.width != "undefined")
      width = args.width;
    $(lfjs.bubble.domobj).width(width);

    if(typeof(bubbleTheme) !== "undefined")
      $(".lfjsbubble").addClass(bubbleTheme);

    $(lfjs.bubble.domobj).find(".lfjsbubblecontent").html(message);
    if(!$(lfjs.bubble.domobj).find("#lfjsbubbleclose").length) {
      var closeBtn = document.createElement("a");
      $(closeBtn).attr({ id: "lfjsbubbleclose", href: "#", role: "button" })
        .html('<span class="sr-only">Close</span>')
        .click(function(e) {
        e.preventDefault();
        lfjs.bubble.hide();
      })
        .keypress(function(ev) {
          if(ev.charCode && ev.charCode === 32) {
            //close on space bar, because it's acting as a button
            ev.preventDefault();
            lfjs.bubble.hide();
          }
        });
      $(lfjs.bubble.domobj).prepend(closeBtn);
    }
    $(lfjs.bubble.domobj).find(".lfjsbubblecontent").html(message);
    if (domobj) {
      var position = lfjs.bubble.calculatePosition(domobj, belowContent);
      var tail = $(".lfjsbubbletail");
      tail.show();

      $(lfjs.bubble.domobj).css({ position: "absolute", top: position.top, left: position.left}).show().click(function() {
        return false;
      });

      $(lfjs.bubble.domobj).find("a, :input").click(function(event) {
        event.stopImmediatePropagation();
        return true;
      });
      domobj.blur();
      setTimeout(function() {
        $(document.body).bind("click.hidebubble", function(event) {
          lfjs.bubble.hide();
        });
      }, 1);
    }
  }
  lfjs.bubble.calculatePosition = function(domobj, belowContent) {
    belowContent = (typeof belowContent != "undefined") ? belowContent : false;

    //Return object with top/left locations
    var toReturn = {};

    if (!domobj)
      return;

    var off = $(domobj).offset();
    var dw = $(domobj).width();

    var w = $(lfjs.bubble.domobj).width();
    var h = $(lfjs.bubble.domobj).height();

    toReturn.top = off.top - h - 20;
    toReturn.left = off.left - ((w - 70) - (dw / 2));

    //Top will be changed depending on whether we are rendering above or below the content
    var tail = $(".lfjsbubbletail");
    tail.removeClass("top left");

    if (belowContent)
    {
      toReturn.top = toReturn.top + (height) + 30;        //Calculate new top
      tail.addClass("top");                   //Add top class to flip the image
      return;
    }

    //Check if bubble will be out of sight (above or below)
    var windowHeight = $(window).height();
    var docTop = $(window).scrollTop();
    var docBottom = docTop + windowHeight;

    //Calculate the new bottom
    //  (add twice the height to get bottom of bubble displayed below)
    var bottom = toReturn.top + (2*h) + 20;

    if ((bottom >= docBottom) && (toReturn.top <= docTop))
    {
      //Off of top of screen completely or Off screen on both top and bottom - display based on which is off by the "least"
      if (toReturn.top < 0 || ((bottom - docBottom) < (docTop - toReturn.top)))
      {
        //Off on bottom by more than it is on top... display on top
        toReturn.top  = toReturn.top + (h) + 30;       //Calculate new top
        tail.addClass("top");       //Add top class to flip the tail
      }
    }

    //Off on top - display below
    else if (toReturn.top <= docTop)
    {
      toReturn.top  = toReturn.top + (h) + 55;       //Calculate new top
      tail.addClass("top");       //Add top class to flip the tail
    }


    //center bubble tail overr domobj
    if (toReturn.left < 0) {
      var right = w - (off.left + 25)
      //console.log("Right: " + right + " - Width: " + w)
      tail.css("right", right + "px")
      toReturn.left = 0;
    }
    else
    {
      tail.css("right", "70px")
    }

    return toReturn;
  };

  lfjs.bubble.hide = function() {
    if (typeof lfjs.bubble.domobj != "undefined") {
      $(lfjs.bubble.domobj).hide().unbind('keydown.keepfocus');
    }
    $(document.body).unbind("click.hidebubble");
    $(lfjs.bubble.prevdomobj).focus();
  }
  lfjs.bubble.createBubble = function() {
    if(typeof lfjs.bubble.domobj != "undefined")
      return;
    var div = document.createElement("div");
    var html = '<div class="lfjsbubblemain">';
    html += '<div class="lfjsbubblecontent"></div><div class="lfjsbubbletail"></div></div>';
    $(div).addClass("lfjsbubble").attr("role","tooltip").html(html).hide().appendTo(document.body);
    lfjs.bubble.domobj = div;
  }
  lfjs.bubble.defaultKeyHandler = function (key) {
    switch (key) {
      case 'ESC':
        lfjs.bubble.hide();
        return false;
    }
    return true;
  };
})(jQuery);
